export default __webpack_public_path__ + "static/media/allgemein_22.0d878279.jpg";